import { Component, Output, Input, OnInit, OnDestroy } from "@angular/core";
import * as _ from "lodash";
import { Subject } from "rxjs";
import { DocumentListItemDTO } from "../../models/documentListItemsDTO";
import { DocumentListService } from "../../services/documentList.service";
import { DataConvertingService } from "src/app/shared/services/data-converting.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  SignedDocumentRejectionModalComponent,
  SignedDocumentRejectionResponse,
} from "../signed-document-rejection-modal/signed-document-rejection-modal.component";
import { first, takeUntil } from "rxjs/operators";

export interface SignedDocumentApprovalResponse {
  item: DocumentListItemDTO;
  remarks: string;
}

@Component({
  selector: "app-signed-document-approval",
  templateUrl: "./signed-document-approval.component.html",
  styleUrls: ["./signed-document-approval.component.scss"],
})
export class SignedDocumentApprovalComponent implements OnInit, OnDestroy {
  @Input() item: DocumentListItemDTO;
  @Output() back: Subject<void> = new Subject<void>();

  @Output()
  validate: Subject<DocumentListItemDTO> = new Subject<DocumentListItemDTO>();
  @Output()
  reject: Subject<SignedDocumentApprovalResponse> = new Subject<SignedDocumentApprovalResponse>();

  pdf: string;

  constructor(
    private readonly service: DocumentListService,
    private readonly dataService: DataConvertingService,
    private readonly modalService: NgbModal
  ) {}

  ngOnInit(): void {
    const url = this.item.signedDocumentUrl;
    this.pdf = url;
    // tODO: get from backend by URL
    // this.service.getDocumentData(url)
    //     .subscribe(blob =>  {
    //         this.dataService.blobToArrayBuffer(blob)
    //             .subscribe(x => this.pdf = x);
    //     });
  }

  onBack() {
    this.back.next();
  }

  onValidate() {
    this.validate.next(this.item);
  }

  onReject() {
    const modalRef = this.modalService.open(
      SignedDocumentRejectionModalComponent
    );
    modalRef.componentInstance.save
      .pipe(first())
      .subscribe((res: SignedDocumentRejectionResponse) => {
        this.reject.next({ ...res, item: this.item });
      });
  }

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
